"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideBtnOutcomes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_router_1 = require("react-router");
const zustandStore_1 = require("../../../../../zustandStore");
const approvalHelpers_1 = require("../../approvalHelpers");
const reassignButton_1 = require("./reassignButton");
const lexico = new lexico_1.default();
exports.hideBtnOutcomes = ['APPROVED', 'REJECTED', 'CANCELLED', 'CARD-CANCELED'];
const CreateCardButton = ({ approvalItem }) => {
    const params = (0, react_router_1.useParams)();
    const { state, exceedsApprovalLimit, outcome, featureAccess } = approvalItem || {};
    const viewAllApprovals = (0, zustandStore_1.useZustand)(state => state.activity.viewAllApprovals);
    const isActivityPage = globalThis.location.pathname.includes('activity');
    const isActivityOrConversationPage = isActivityPage || globalThis.location.pathname.includes('approval');
    const isActionable = (isActivityPage && !viewAllApprovals) || (state === 'ASSIGNED' && !(0, approvalHelpers_1.isProcessing)(approvalItem));
    const activeHeaderTab = (0, zustandStore_1.useZustand)(state => state.header.activeHeaderTab);
    const { showCreateFwdButtons, showNoActiveCardInfo, isCreateCardSuccessful } = (0, zustandStore_1.useZustand)(state => state.approvals);
    const { setIsCreateCardAsideOpen, setCreateCardAsideApproval } = (0, zustandStore_1.useZustand)();
    const showBtnCondition = (outcome === undefined && approvalItem.isPending) || !exports.hideBtnOutcomes.includes(outcome) || approvalItem.isPending
        ? isActionable && !exceedsApprovalLimit && !showNoActiveCardInfo
        : false;
    const isOnActivityPage = (location.pathname.startsWith('/approvals') || location.pathname.startsWith('/activity')) && !params['approvalId'];
    const showBtn = isOnActivityPage
        ? showBtnCondition && activeHeaderTab === 'pending'
        : showBtnCondition && showCreateFwdButtons && !isCreateCardSuccessful && activeHeaderTab
            ? activeHeaderTab === 'pending'
            : showBtnCondition;
    const status = (0, reassignButton_1.getStatus)(approvalItem);
    const isReassignableToSelf = featureAccess &&
        featureAccess.reassignRequestToSelf &&
        (status === 'pending-forwarded' || status === 'forwarded-pending');
    const showReassignBtn = isReassignableToSelf &&
        outcome === 'REASSIGNED' &&
        isActivityOrConversationPage &&
        !viewAllApprovals &&
        !approvalItem.currentUserIsNotAssigneerByUserId;
    return (showBtn &&
        !showReassignBtn && ((0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", style: {
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? { textTransform: 'uppercase' } : {}),
        }, onClick: () => {
            setIsCreateCardAsideOpen(true);
            setCreateCardAsideApproval(approvalItem);
        }, children: lexico.trc('Button', globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'Approve Card' : 'Create card') })));
};
exports.default = CreateCardButton;
